import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { NavLink, Link, useHistory } from "react-router-dom";
import Select from "react-select";

import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";

import SwalToast from "../../../../components/helpers/SwalToast";
import AppRoutePath from "../../../../router/AppRoutePath";
import { PermissionContext } from "../../../../components/context/PermissionContext";
import { initFilterInput, renderColumns } from "./constants";
import { convertEmployeeList } from "./helpers/convertEmployeeList";
import CustomTable from "../../../../components/common/Table/CustomTable";
import { convertOutletList } from "./helpers/convertOutletList";
import { TiUser } from "react-icons/ti";
import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import { convertJabatanList } from "./helpers/convertJabatanList";
import Swal from "sweetalert2";
import httpclient from "../../../../components/httpclient";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../components/template/authorization/Authorization";
import { Button } from "antd";

export default function Employee(props) {
  const [records, setRecords] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [jabatanList, setJabatanList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getData();
  }, [filterInput]);

  useEffect(() => {
    getOutlet();
    getJabatan();
  }, []);

  const getData = () => {
    let params = {
      name: filterInput.searchName,
      outlet_id: filterInput.outlet,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      jabatan_id: filterInput.jabatan,
      sort_by: filterInput.sortBy,
      order_by: filterInput.orderBy,
    };
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}employee`;
    console.log(params);
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setRecords(convertEmployeeList(response.data.data.items));
        setTotalRecord(response.data.data.total_item);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        setLoading(false);
        console.log(error.response);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));
      },
      (error) => {
        console.log(error.response);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getJabatan = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}jabatan`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setJabatanList(convertJabatanList(response.data.data.items));
      },
      (error) => {
        console.log(error.response);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      sortBy: sorter?.column?.backend_key || null,
      orderBy:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleEdit = (record) => {
    history.push(`${AppRoutePath.USERS_EDIT_EMPLOYEE}`);
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}employee/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus user " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    });
  };

  const handleDetail = (record) => {
    history.push(`/view_employee/${record.id}`);
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        pageSize: parseInt(value),
      }));
    }
    if (name === "name") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
  };

  const handleDropdown = (e) => {
    if (e.type === "outlet") {
      setFilterInput((prev) => ({
        ...prev,
        outlet: parseInt(e.value),
      }));
    }
    if (e.type === "jabatan") {
      setFilterInput((prev) => ({
        ...prev,
        jabatan: parseInt(e.value),
      }));
    }
  };

  return (
    <div>
      <div className="p-3">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="">
            <Title text="Semua Pegawai" />
            <Breadcrumb current="Semua Pegawai" />
          </div>
          <div
            style={{
              padding: 13,
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 50,
              width: 222,
            }}
          >
            <div
              style={{
                fontSize: 18,
                color: "#303030",
              }}
            >
              <TiUser
                style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
              />
              <span style={{ fontWeight: 700 }}>{totalRecord}</span> Total
              Pegawai
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: 20,
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div className="d-flex" style={{ flex: 4 }}>
            <div className="mt-3 col-1 pl-0">
              <label htmlFor="show" className="">
                Tampilkan:
              </label>
              <input
                name="pageSize"
                id="show"
                type="number"
                className="form-control border-97A0AE"
                value={filterInput.pageSize}
                onChange={handleFilterChanged}
              />
            </div>
            <div className="mt-3 col-4">
              <label htmlFor="search_name" className="">
                Nama Pegawai :
              </label>
              <input
                name="name"
                id="search_name"
                type="text"
                className="form-control border-97A0AE"
                placeholder="Ketikkan Nama"
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div className="pl-3 mt-3 col-3">
              <label htmlFor="search_name" className="">
                Cabang :
              </label>
              <Select
                name="outlet"
                options={outletList}
                onChange={handleDropdown}
              />
            </div>
            <div className="pl-1 mt-3 col-3" style={{ zIndex: 10 }}>
              <label htmlFor="search_name" className="">
                Jabatan :
              </label>
              <Select
                name="jabatan"
                options={jabatanList}
                onChange={handleDropdown}
              />
            </div>
            <div className="filter-bar d-flex align-items-end">
              <Button
                type="link"
                className="btn-action btn-reset"
                onClick={() => setFilterInput(initFilterInput)}
              >
                Reset semua filter
              </Button>
            </div>
          </div>
          <div style={{ flex: 2, display: "flex", justifyContent: "flex-end" }}>
            <CanAccess
              role={AuthorizationList.create_employee}
              yes={
                <Link to={AppRoutePath.USERS_ADD_EMPLOYEE}>
                  <Button
                    style={{
                      alignSelf: "flex-end",
                      height: 36,
                      background: "#2C465C",
                      color: "#FFF",
                      width: 180,
                      borderRadius: 6,
                    }}
                  >
                    + Tambah Pegawai
                  </Button>
                </Link>
              }
            />
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            columns={renderColumns(handleDelete, handleDetail)}
            data={records}
            loading={loading}
            handleTableChange={handleTableChange}
            pagination={tablePagination}
          />
        </div>
      </div>
    </div>
  );
}
